"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.validateTextLength = exports.toPascalCase = exports.snakeToCamelWithSpecialCases = exports.nlToBr = exports.deleteTrailingSlash = exports.default = void 0;

var _camelCase = _interopRequireDefault(require("lodash/camelCase"));

var _startCase = _interopRequireDefault(require("lodash/startCase"));

const toPascalCase = str => (0, _startCase.default)((0, _camelCase.default)(str)).replace(/ /g, '');

exports.toPascalCase = toPascalCase;

const nlToBr = str => str === null || str === void 0 ? void 0 : str.replace(/\n/g, '<br />');

exports.nlToBr = nlToBr;

const camelCaseKey = key => {
  const toUpperCase = ['ui'];
  const parts = key.split('_');
  const camelCaseParts = parts.map((part, index) => {
    if (index === parts.length - 1 && toUpperCase.includes(part.toLowerCase())) {
      return part.toUpperCase();
    }

    return index === 0 ? part : part.charAt(0).toUpperCase() + part.slice(1);
  });
  return camelCaseParts.join('');
};

const snakeToCamelWithSpecialCases = inputObject => {
  // TODO - replace above camelCaseKey with version below after https://bitbucket.org/rbdigital/phx-husky/pull-requests/893 merge
  // const camelCaseKey = (str: string) =>
  // str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
  if (Array.isArray(inputObject)) {
    return inputObject.map(item => typeof item === 'object' && item !== null ? snakeToCamelWithSpecialCases(item) : item);
  }

  if (typeof inputObject === 'object' && inputObject !== null) {
    const camelCaseObj = {};
    Object.entries(inputObject).forEach(([key, value]) => {
      camelCaseObj[camelCaseKey(key)] = typeof value === 'object' && value !== null ? snakeToCamelWithSpecialCases(value) : value;
    });
    return camelCaseObj;
  }

  return inputObject;
};

exports.snakeToCamelWithSpecialCases = snakeToCamelWithSpecialCases;
const stringUtils = {
  toPascalCase,
  nlToBr,
  snakeToCamelWithSpecialCases
};

const validateTextLength = button => {
  const MAX_LENGTH_WITH_ICON = 18;
  const MAX_LENGTH_WITHOUT_ICON = 22;

  if (button.text.length > MAX_LENGTH_WITH_ICON && button.iconPrefix.length > 0 || button.iconSuffix.length > 0) {
    return `${button.text.slice(0, MAX_LENGTH_WITH_ICON)}`;
  }

  if (button.text.length > MAX_LENGTH_WITHOUT_ICON) {
    return `${button.text.slice(0, MAX_LENGTH_WITHOUT_ICON)}`;
  }

  return button.text;
};

exports.validateTextLength = validateTextLength;
var _default = stringUtils;
exports.default = _default;

const deleteTrailingSlash = (str, force) => {
  if (force || process.env.GATSBY_TRAILING_SLASH === 'false') {
    return (str === null || str === void 0 ? void 0 : str.slice(-1)) === '/' ? str === null || str === void 0 ? void 0 : str.slice(0, -1) : str;
  }

  return str;
};

exports.deleteTrailingSlash = deleteTrailingSlash;